import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NaruceneKolicineGrupeService {
  constructor(private _http: HttpClient) {}

  dohvatiNaruceneKolicine(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'narucene_kolicine_partnergrupa', a)
      .pipe(map((res: any) => res));
  }

  dohvatiGrupePartnera(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_partnergrupe', a)
      .pipe(map((res: any) => res));
  }
}
